export default __webpack_public_path__ + "static/media/active_heart.563b046a.svg";